import { GlobalStateActions, GlobalStateType } from "./types";
import { SET_ACTIVE_PAGE_NAME } from "./actionTypes";

const initialState: GlobalStateType = {
  activePageName: "",
};

const reducer = (
  state = initialState,
  action: GlobalStateActions
): GlobalStateType => {
  switch (action.type) {
    case SET_ACTIVE_PAGE_NAME:
      return {
        ...state,
        activePageName: action.payload.pageName,
      };
    default:
      return state;
  }
};

export default reducer;
